import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";
import { useText } from "@/lib/useText";
import { useStorePackages, VipSpotlight } from "@/components/site/StorePackages";

export function StoreTeaser() {
  const { content, preview } = useContent();
  const t = useText();
  const data = useStorePackages();
  const list = data?.packages || [];
  if (!list.length) return null;
  return (
    <section data-reveal className="border-t border-eden-border py-20 sm:py-28" aria-labelledby="vip-title" data-testid="store-teaser-section">
      <div className="container-eden grid gap-10 lg:grid-cols-12 lg:items-center">
        <div className="lg:col-span-5">
          <p className="eyebrow mb-4">{content.store.eyebrow}</p>
          <h2 id="vip-title" className="text-2xl font-bold tracking-tight text-eden-text sm:text-3xl lg:text-4xl">{t("vip_title")}</h2>
          <p className="mt-4 text-eden-secondary">{t("vip_text")}</p>
          <Link to={`/loja${preview ? "?preview=1" : ""}`} className="mt-8 inline-flex items-center gap-1.5 text-sm font-medium text-eden-text underline-offset-4 hover:text-eden-orange hover:underline" data-testid="store-teaser-link">
            {t("vip_all")} <ArrowRight size={16} aria-hidden="true" />
          </Link>
        </div>
        <div className="lg:col-span-6 lg:col-start-7">
          <VipSpotlight packages={list} compact />
        </div>
      </div>
    </section>
  );
}
